<template>
  <div>
    <v-data-table
      ref="dataContainer"
      :headers="headers"
      :items="loadItems"
      class="elevation-1"
      :loading="loading"
      hide-default-footer
      style="min-height: 100%;"
      id="audit-log-event__table"
      fixed-header
      height="100%"
    >
      <template v-slot:body.append>
        <td :colspan="headers.length" class="text-center py-2" v-if="loading">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </td>
      </template>
      <template v-slot:item.action_name="props">
        <v-chip
          small
          :color="util.parseColor(props.item.action_name)"
          text-color="audit_log__action__text_color"
          >{{ props.item.action_name }}</v-chip
        >
      </template>
      <template v-slot:item.time="props">
        <span>{{ parseLogDatetime(new Date(props.item.time)) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { handleError } from "@/utils/error";
import util from "@/modules/logs/audit-log/util";
import { logMixins } from "@/modules/logs/mixins";
export default {
  mixins: [logMixins],
  data() {
    return {
      headers: [
        {
          text: this.$t("modules.logs.auditLog.time"),
          align: "start",
          value: "time"
        },
        {
          text: this.$t("modules.logs.auditLog.username"),
          align: "left",
          value: "username"
        },
        {
          text: this.$t("modules.logs.auditLog.resource"),
          align: "start",
          value: "resource_name"
        },
        {
          text: this.$t("modules.logs.auditLog.entity"),
          align: "start",
          value: "entity_name"
        },
        {
          text: this.$t("modules.logs.auditLog.action"),
          align: "center",
          value: "action_name"
        },
        {
          text: this.$t("modules.logs.auditLog.detail"),
          align: "start",
          value: "detail"
        }
      ],
      util
    };
  },
  computed: {
    auditLog() {
      return this.$store.state.auditLog.auditLog.map(item => {
        item.resource_name = this.util.parseResource(item.resource);
        item.action_name = this.util.parseAction(item.action);
        return item;
      });
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      this.$store
        .dispatch("auditLog/fetchAll")
        .then(() => {
          this.loadItems = [...this.loadItems, ...this.auditLog].slice(0, 2);
        })
        .catch(error => {
          handleError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
